import { render, staticRenderFns } from "./PaymentDescription.vue?vue&type=template&id=01efd974&scoped=true"
import script from "./PaymentDescription.vue?vue&type=script&lang=ts"
export * from "./PaymentDescription.vue?vue&type=script&lang=ts"
import style0 from "./PaymentDescription.vue?vue&type=style&index=0&id=01efd974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01efd974",
  null
  
)

export default component.exports